/**
 * ShiptimizeAjax — all server communication in one place.
 *
 * Every method returns a Promise so callers can handle success/failure
 * explicitly. No state mutations happen here — this module only talks
 * to the server and returns what it gets back.
 */
export default class ShiptimizeAjax {
  /**
   * @param {string} ajaxUrl  WordPress admin-ajax.php URL
   * @param {string} nonce    shiptimize_vars.nonce
   */
  constructor(ajaxUrl, nonce) {
    this._url   = ajaxUrl;
    this._nonce = nonce;
  }

  /**
   * Fetch pickup locations near an address for a given carrier.
   *
   * @param {object} address   Address object { Streetname1, City, PostalCode, Country, Lat, Long, … }
   * @param {number} carrierId Shiptimize API carrier ID
   * @returns {Promise<object>}
   */
  getPickupLocations(address, carrierId) {
    return new Promise((resolve, reject) => {
      jQuery
        .getJSON(this._url, {
          action:    'shiptimize_pickup_locations',
          Address:   address,
          CarrierId: carrierId,
        })
        .done(resolve)
        .fail((xhr, status, err) => reject(new Error(err || status)));
    });
  }

  /**
   * Tell the server to clear all pickup session data.
   * Call this when the customer changes address or switches to a carrier
   * that doesn't support pickup.
   *
   * @returns {Promise<void>}
   */
  clearPickupSession() {
    return new Promise((resolve, reject) => {
      jQuery
        .post(this._url, {
          action:           'shiptimize_clear_pickup_session_data',
          shiptimize_nonce: this._nonce,
        })
        .done(resolve)
        .fail((xhr, status, err) => reject(new Error(err || status)));
    });
  }

  /**
   * Get the current checkout address from the server session.
   * Used as a fallback when client-side address extraction is unreliable.
   *
   * @returns {Promise<object>}
   */
  getCheckoutAddress() {
    return new Promise((resolve, reject) => {
      jQuery
        .get(this._url, { action: 'shiptimize_get_checkout_address' })
        .done((response) => {
          try {
            resolve(typeof response === 'string' ? JSON.parse(response) : response);
          } catch (e) {
            reject(e);
          }
        })
        .fail((xhr, status, err) => reject(new Error(err || status)));
    });
  }
}
